export default __webpack_public_path__ + "static/media/Footpad's Leggings of the Final Way.3f5bfa52.jpg";